export default function buildGetPrivateProducerApplications({
    apiEndpoint,
    apiTools
}) {
    return async function getPrivateProducerApplications(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/private`
        })
       
        const res = await fetch(url, {
            method: 'GET',
            credentials: 'include',
        });
        return await res.json();
    }
}